import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { YoutubeIcon, ExternalLinkIcon } from 'lucide-react';
export function YouTubeCTA() {
  const {
    isArabic
  } = useLanguage();
  return <div className="bg-gradient-to-r from-red-50 to-red-100 dark:from-red-900/20 dark:to-red-900/10 rounded-xl p-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-1717">
      <div className="flex items-center gap-4" data-id="element-1718">
        <div className="p-3 bg-red-100 dark:bg-red-900/30 rounded-full" data-id="element-1719">
          <YoutubeIcon className="w-8 h-8 text-red-600 dark:text-red-400" data-id="element-1720" />
        </div>
        <div data-id="element-1721">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-1" data-id="element-1722">
            {isArabic ? 'تابعنا على قناة يوتيوب' : 'Follow Our YouTube Channel'}
          </h3>
          <p className="text-gray-600 dark:text-gray-300" data-id="element-1723">
            {isArabic ? 'احصل على المزيد من دروس اللغة الإنجليزية المجانية' : 'Get more free English lessons and tutorials'}
          </p>
        </div>
      </div>
      <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors flex items-center gap-2 whitespace-nowrap" data-id="element-1724">
        <span data-id="element-1725">{isArabic ? 'زيارة القناة' : 'Visit Channel'}</span>
        <ExternalLinkIcon className="w-4 h-4" data-id="element-1726" />
      </a>
    </div>;
}